
export const getValidDate = (date: Date | string) => {
  const _date = new Date(date);
  if (isNaN(_date.valueOf())) {
    throw new Error('Invalid Date');
  }
  return _date;
};

export const destructDate = (date: Date | string) => {
  try {
    const _date = getValidDate(date);
    return [
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds(),
    ];
  } catch (err) {
    throw new Error('cannot destruct Date');
  }
};

export const formatParamDate = (date: Date | string) => {
  try {
    const _date = getValidDate(date);

    const [year, M, d] = destructDate(_date);
    const _M = M + 1;
    const month = _M < 10 ? `0${_M}` : `${_M}`;
    const day = d < 10 ? `0${d}` : `${d}`;
    return `${year}-${month}-${day}`;
  } catch (err) {
    throw new Error('cannot format Date');
  }
};
